import React from 'react';
import {withRouter} from 'react-router-dom';
import {Alert} from 'componentLibrary';
import {FemaGoModal} from 'app-ui-componentlibrary';
import _ from 'lodash';
import REST from 'go/requests/rest';
import {Dimmer, Loader} from 'semantic-ui-react';
import {checkProcessInstanceTerminated, ISOToDisplayDate} from 'common/utils';
class ReopenApplicationModal extends React.Component {
  state = {
    open: false,
    reopening: false,
    message: '',
    fundingOpportunity: {},
  };

  componentDidMount() {
    this.refreshData();
  }

  componentDidUpdate(prevProps) {
    this.refreshData();
  }

  refreshData() {
    const {open, token, entity} = this.props;
    const {fundingOpportunity} = this.state;
    let foId = entity.fundingOpportunityId;

    if (!_.isEqual(fundingOpportunity.fundingOpportunityId, foId)) {
      REST.fundingOpportunity
        .getFundingOpportunity(token, entity.fundingOpportunityId)
        .then(REST.handler.handleResponse)
        .then((foData) => {
          if (foData)
            this.setState({
              fundingOpportunity: foData,
              fundingOpportunityId: foId,
              message: '',
              open: this.props.open,
            });
          else {
            this.setState({
              message:
                'Unable to retrieve the program information: You might not be authorized to access this funding opportunity :' +
                foId,
              open: this.props.open,
            });
          }
        });
    } else if (!_.isEqual(open, this.state.open)) {
      this.setState({open: this.props.open});
    }
  }

  handleConfirm = () => {
    const {token, entity, history} = this.props;
    const {fundingOpportunity} = this.state;
    const data = {entity: entity, fundingOpportunity: fundingOpportunity};
    REST.workflow
      .sendSignal(token, data, 'reopen-application')
      .then(REST.handler.handleResponse)
      .then((res) => {
        // TODO remove OpenAPI toggle code
        let processInstanceId = _.isObject(res) ? _.get(res, 'result') : res;
        this.setState({reopening: true});
        checkProcessInstanceTerminated(entity, token, processInstanceId, (entity) => {
          this.setState({open: false, reopening: false, message: ''}, () =>
            history.push(`/application/${entity.entityId}/edit`)
          );
        });
      })
      .catch((error) => {
        this.setState({
          reopening: false,
          message: 'An error happened while trying to reopen this application.',
        });
        console.error('An error happened while trying to reopen this application: ');
      });
  };

  handleCancel = () => {
    const cancel = () => this.props.onCancel();
    this.setState({open: false, fundingOpportunity: {}});
    cancel();
  };

  render() {
    const {entity} = this.props;

    const {open, reopening, fundingOpportunity, message} = this.state;

    return (
      open && (
        <FemaGoModal
          type="alert"
          size="medium"
          title="Reopen application"
          className="modal-title"
          open={open}
          confirmAction={this.handleConfirm}
          buttonText="Yes"
          cancelButtonText="Cancel"
          buttonType={'primary'}
          cancelAction={this.handleCancel}
        >
          <hr />
          {!_.isEmpty(message) && (
            <Alert header="" htmlContent={message} alertType="error" />
          )}
          {reopening && (
            <Dimmer active>
              <Loader />
            </Dimmer>
          )}
          <p>
            <strong>Application information:</strong>
          </p>
          <p>
            <strong>{fundingOpportunity.fundingOpportunityName}</strong>
          </p>
          <p>
            <strong>{`Application ID:  ${entity.grantId}`}</strong>
          </p>
          <p>
            {`If you reopen this application, it will not be considered for award.  You have to resubmit the application before the submission deadline of ${ISOToDisplayDate(
              fundingOpportunity.aplcnEndDate,
              {
                showHours: true,
                showDate: true,
                describeMonth: true,
                useUserTimezone: true,
              }
            )} to be considered for an award.`}
          </p>
          <br />
          <p>Are you sure you want to reopen the application?</p>
        </FemaGoModal>
      )
    );
  }
}

export default withRouter(ReopenApplicationModal);
